<template>
	<div class="BtnOut">
		<!-- 使能按钮 -->
		<div
			v-show="!dis"
			class="btn pointer"
			@click="$emit('clk')">
			{{ text }}
			<slot />
		</div>
		<!-- 置灰按钮 -->
		<div
			v-show="dis"
			class="btn2 pointer">
			{{ text }}
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'Btn',
	// dis 按钮置灰
	props: {
		text: {
			type: String,
			required: true, // 如果 text 是必传的
		},
		dis: {
			type: Boolean,
			default: false, // 如果 dis 有默认值
		},
	},
}
</script>

<style lang="scss" scoped>
.btn {
	// margin: auto;
	width: fit-content;
	display: block;
	color: #fff;
	font-family: 'Bakbak One';
	font-size: rem(24);
	font-style: normal;
	font-weight: 400;
	line-height: rem(24); /* 100% */
	font-size: rem(24);
	border-radius: rem(100);
	padding: rem(22) rem(45);
	text-align: center;
	background: linear-gradient(96deg, #3CCA7C 0%, #28C5C2 100%);
}
.btn2 {
	// margin: auto;
	width: fit-content;
	display: block;
	color: #999;
	font-family: 'Bakbak One';
	font-size: rem(24);
	font-style: normal;
	font-weight: 400;
	line-height: rem(24); /* 100% */
	font-size: rem(24);
	border-radius: rem(100);
	padding: rem(22) rem(45);
	text-align: center;
	background: #393939;
}
</style>
